import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { AreaRestritaSharedModule } from '../../shared/area-restitra.shared.module';
import { ContrachqueAposentadoPdf } from '../../shared/services/documentos-pdf-imprimir/financeiro/contracheques/contracheque-aposentados-pdf';
import { PessoaService } from '../../shared/services/pessoa.service';
import { ContrachequeAposentadoComponent } from './contracheque-aposentado/contracheque-aposentado.component';
import { ContrachequeFuncionarioComponent } from './contracheque-funcionario/contracheque-funcionario.component';
import { ContrachequeComponent } from './contracheque.component';
import { ContrachequeRoutingModule } from './router/contracheque.router';
import { ContrachequeService } from './service/contracheque.service';

@NgModule({
    imports: [
        CommonModule,
        AreaRestritaSharedModule,
        ContrachequeRoutingModule
    ],
    declarations: [
        ContrachequeComponent,
        ContrachequeFuncionarioComponent,
        ContrachequeAposentadoComponent
    ],
    providers: [
        DecimalPipe,
        ContrachqueAposentadoPdf,
        PessoaService,
        ContrachequeService
    ]
})
export class ContrachequeModule {

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/financeiro/contracheque/contraceque.module.ts